import { render, staticRenderFns } from "./crearUnidadEmbalaje.vue?vue&type=template&id=dc0f804c"
import script from "./crearUnidadEmbalaje.vue?vue&type=script&lang=js"
export * from "./crearUnidadEmbalaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports